export default __webpack_public_path__ + "static/media/DOMINIC.ba5cd455.png";